import {
  SET_ONBOARDING_FLOWS,
  SET_ONBOARDING_FORMS,
  SET_ONBOARDING_RUNS,
  SET_ONBOARDING_DOCUMENTS,
  SET_ONBOARDING_CHECKLIST_TEMPLATES,
  SET_ONBOARDING_HR_ASSIGNEES,
  SET_ONBOARDING_SETTINGS,
  SET_ONBOARDING_RUN_DETAIL,
  SET_ONBOARDING_PORTAL,
} from '../Types/types';

const initialState = {
  flows: [],
  flowsPagination: {},
  forms: [],
  formsPagination: {},
  runs: [],
  runsPagination: {},
  runDetail: null,
  documents: [],
  checklistTemplates: [],
  checklistPagination: {},
  hrAssignees: [],
  settings: null,
  portal: null,
};

export default function onboardingReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ONBOARDING_FLOWS:
      return {
        ...state,
        flows: action.payload?.data || action.payload || [],
        flowsPagination: action.payload?.pagination || {},
      };
    case SET_ONBOARDING_FORMS:
      return {
        ...state,
        forms: action.payload?.data || action.payload || [],
        formsPagination: action.payload?.pagination || {},
      };
    case SET_ONBOARDING_RUNS:
      return {
        ...state,
        runs: action.payload?.data || action.payload || [],
        runsPagination: action.payload?.pagination || {},
      };
    case SET_ONBOARDING_RUN_DETAIL:
      return { ...state, runDetail: action.payload?.data || action.payload };
    case SET_ONBOARDING_DOCUMENTS:
      return { ...state, documents: action.payload?.data || action.payload || [] };
    case SET_ONBOARDING_CHECKLIST_TEMPLATES:
      return {
        ...state,
        checklistTemplates: action.payload?.data || action.payload || [],
        checklistPagination: action.payload?.pagination || {},
      };
    case SET_ONBOARDING_HR_ASSIGNEES:
      return { ...state, hrAssignees: action.payload?.data || action.payload || [] };
    case SET_ONBOARDING_SETTINGS:
      return { ...state, settings: action.payload?.data || action.payload };
    case SET_ONBOARDING_PORTAL:
      return { ...state, portal: action.payload?.data || action.payload };
    default:
      return state;
  }
}
